// Sugalarm — `useSyncExternalStore` subscription on `alarmPreview.ts`
// state (cycle 36). Returns the live `PreviewState` so any screen can
// render against "is a preview active and what zone."
//
// The store is a plain module-level value + a custom event, mirroring
// the pattern the retired test-mode flag used. The snapshot is the
// `PreviewState` object reference; mutations always swap the reference
// so React's identity-based bailout works without a manual selector.

import { useSyncExternalStore } from "react";

import {
  getPreviewState,
  subscribePreview,
  type PreviewState,
} from "../lib/alarmPreview";

const SSR_SNAPSHOT: PreviewState = { zone: null, startedAt: 0, sgv: null };

export function useAlarmPreview(): PreviewState {
  return useSyncExternalStore(
    subscribePreview,
    getPreviewState,
    () => SSR_SNAPSHOT,
  );
}
